import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthStore, UserRole } from './auth.store';

@Injectable({ providedIn: 'root' })
export class RoleBasedAccessService {
  router = inject(Router);
  authStore = inject(AuthStore);
  appRecognizedRoles: UserRole[] = [UserRole.UpdateManager, UserRole.User, UserRole.AppDeveloper];

  canAccessRoute(routePath?: string) {
    const userRoles = this.authStore.userRoles();
    const hasRecognizedRole = userRoles.some(role => this.appRecognizedRoles.includes(role));

    if (!hasRecognizedRole) return false;

    const requestedRoutePath = routePath ?? this.getParentRoutePath();

    const hasFullAccess = userRoles.some(
      role => role === UserRole.UpdateManager || role === UserRole.AppDeveloper
    );

    const commonRoutePaths = ['/all-devices', '/'];

    if (!hasFullAccess && !commonRoutePaths.includes(requestedRoutePath)) return false;
    return true;
  }

  protected getParentRoutePath() {
    const parentUrlSegment = this.router.url.split('/')[1];
    return `/${parentUrlSegment}`;
  }
}
